import { api } from "@/builders/axios";
import { QRCodeData } from "@/builders/types/two-fa";
import { StaffLoginResponse } from "../types/login";

const generate = function (data: { email: string }) {
  return api
    .post<QRCodeData>("2fa/generate/app", data)
};

const verify = function (data: { email: string; token: string; otp: string }) {
  return api
    .post<StaffLoginResponse>("2fa/verify", data)
    .then(({ data }) => data);
};

const email_generate = function (data: { email: string }) {
  return api.post("2fa/email-generate", data);
};

const disable = function () {
  return api.delete("2fa/disable");
};

export const two_fa = {
  generate,
  verify,
  email_generate,
  disable,
};
